import React from 'react';
import { Smartphone, UserCheck, Headphones } from 'lucide-react';

export const ServicesSection = () => {
  const services = [
    {
      icon: <Smartphone size={48} />,
      title: 'Smart POS Distribution',
      description: 'Android-based smart terminals with modern payment processing capabilities. Designed for fast deployment and seamless integration with everyday business operations.',
      features: ['Android-based terminals', 'Fast deployment', 'Modern hardware', 'Real-time processing']
    },
    {
      icon: <UserCheck size={48} />,
      title: 'Merchant Onboarding',
      description: 'A streamlined onboarding journey with local support and merchant verification. Built to get businesses up and running quickly without operational friction.',
      features: ['Guided setup', 'Local support', 'Verification', 'Training included']
    },
    {
      icon: <Headphones size={48} />,
      title: 'Technical Support',
      description: 'Hands-on first-line support for device setup and merchant assistance, so teams can stay focused on running their business.',
      features: ['Responsive assistance', 'Device setup', 'Issue resolution', 'Merchant care']
    }
  ];

  return (
    <section id="services" className="section-padding bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Our <span className="gradient-text">Solutions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Focused payment solutions designed to support modern merchants from day one
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="card-hover bg-white p-8 rounded-2xl border border-gray-200 shadow-lg hover:border-[#1E3A8A] transition-all duration-300"
            >
              <div className="text-[#1E3A8A] mb-6">{service.icon}</div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6">{service.description}</p>
              <ul className="space-y-3">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="inline-block w-2 h-2 bg-[#10B981] rounded-full mt-2 mr-3"></span>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
